import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../utils/ErrorHandler";

const initialState = {
  isApplyingDiscount: false,
  isFetchingFranchiseDiscount: false,
};


// Create discount

// Read discounts


// Get available discounts franchise

export const getFranchiseAvailableDiscounts = createAsyncThunk(
  "discounts/getFranchiseAvailableDiscounts",
  async () => {
    try {
      const { data } = await axios.get(`crm-task/?query=all`);
      return data;
    } catch (error) {
      console.error("Error fetching discount data:", error.message);
      throw error;
    }
  }
);

//Get discounts by franchise id 

export const getDiscountsByFranchiseId = createAsyncThunk(
  "discount/getDiscountsByFranchiseId",
  async (id) => {
    try {
      const { data } = await axios.get(`discounts/?franchiseId=${id}&query=all`);
      return data;
    } catch (error) {
      console.error("Error fetching tasks:", error.message);
      throw error;
    }
  }
);

export const getFranchiseDiscount = createAsyncThunk("user/getFranchiseDiscount",
	async (id) => {
		try {
			const data = await axios.get(`user/player-discount/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	});


// Update discount 

// Delete discount

// Assign discount

export const assignDiscounts = createAsyncThunk(
  "discount/assignDiscounts",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`crm-task/discounts`, payload);
      toast.success("Discounts assigned successfully!");
      return data;
    } catch (error) {
      const errorMessage = handleError(error, "Failed to assign discounts");
      return rejectWithValue(errorMessage);
    }
  }
);

// Apply Discount Slice 


export const applyDiscount = createAsyncThunk(
  "discount/applyDiscount",
  async (payload) => {
    try {
      const { data } = await axios.post(`user/player-discount`, payload);
      toast.success("Discount applied successfully!");
      return data;
    } catch (error) {
      toast.error("Error applying discount, please try again.");
      console.error(error.message);
      return {
        message: "error",
      };
    }
  });


const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    clearDiscount: (state) => {
      state.discount = null;
    },
  },
  extraReducers: (builder) => {


    // apply discount
    builder.addCase(applyDiscount.pending, (state) => {
      state.isApplyingDiscount = true;
      state.error = "";
    });
    builder.addCase(applyDiscount.fulfilled, (state, action) => {
      state.isApplyingDiscount = false;

    });
    builder.addCase(applyDiscount.rejected, (state, action) => {
      state.isApplyingDiscount = false;
      state.error = action.payload;
    });
    // get franchise discount
    builder.addCase(getFranchiseDiscount.pending, (state) => {
      state.isFetchingFranchiseDiscount = true;
      state.error = "";
    });
    builder.addCase(getFranchiseDiscount.fulfilled, (state, action) => {
      state.isFetchingFranchiseDiscount = false;

    });
    builder.addCase(getFranchiseDiscount.rejected, (state, action) => {
      state.isFetchingFranchiseDiscount = false;
      state.error = action.payload;
    });
  },
});

export default discountSlice.reducer;
export const { clearDiscount } = discountSlice.actions;